import history from '../../util/history'

const toCreateInvoiceView = reservationId => {
  history.push(`/reservation/${reservationId}/invoice`)

  return true
}

export default toCreateInvoiceView
